export enum KpiTypeEnum {
  INTEGER = 'INTEGER',
  PERCENTAGE = 'PERCENTAGE',
  PARAMETER = 'PARAMETER',
}
